import { render, staticRenderFns } from "./ThankYouSubscribe.vue?vue&type=template&id=1f0b5fd0&scoped=true&"
import script from "./ThankYouSubscribe.vue?vue&type=script&lang=js&"
export * from "./ThankYouSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouSubscribe.vue?vue&type=style&index=0&id=1f0b5fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b5fd0",
  null
  
)

export default component.exports